import { AccountStatus, defaultManageUsersFilterParameters } from '../../../interfaces/ManageUsers';
import { FILTER_CATEGORIES, ROLE_MAP, FILTER_DEFAULTS } from './constants/filterConstants';
export function buildUserRoleFilter(type, prevState, user) {
    return {
        ...prevState,
        [ROLE_MAP[type].email]: user.UserEmail,
        [ROLE_MAP[type].pk]: user.EmpPK,
        UserName: FILTER_DEFAULTS.EMPTY_USERNAME,
        AccountStatus: FILTER_DEFAULTS.DEFAULT_STATUS
    };
}
export function resetFiltersToDefault() {
    return { ...defaultManageUsersFilterParameters };
}
export function getFilterCount(filterParameters) {
    return Object.entries(FILTER_CATEGORIES).reduce((count, [category, filters]) => {
        const currentCategory = category;
        return (count +
            filters.reduce((categoryCount, filter) => {
                const field = filter;
                if (field === 'AccountStatus' && filterParameters[field] !== AccountStatus.Active) {
                    return categoryCount + 1;
                }
                if (currentCategory === 'booleanFilters' && filterParameters[field] !== null) {
                    return categoryCount + 1;
                }
                if (currentCategory === 'valueFilters' && filterParameters[field]) {
                    return categoryCount + 1;
                }
                return categoryCount;
            }, 0));
    }, 0);
}
